module.exports = __webpack_public_path__ + "img/agrs.5a283d97.svg";